import type { TPlayerPowerSource } from '@lucimark/shared/models/player-power'
import { PLAYER_POWER_SOURCES } from '@lucimark/shared/models/player-power'

export interface IAndroidPowerStatus {
  batteryPresent: boolean
  /** Omitted without a battery. */
  batteryPercent?: number
  powerSource: TPlayerPowerSource
  batteryCharging: boolean
}

export function parseAndroidPowerStatus(raw: unknown): IAndroidPowerStatus | null {
  if (raw == null || typeof raw !== 'object') {
    return null
  }
  const o = raw as Record<string, unknown>
  if (typeof o.batteryPresent !== 'boolean') {
    return null
  }
  const powerSource = (PLAYER_POWER_SOURCES as readonly unknown[]).includes(o.powerSource)
    ? o.powerSource as TPlayerPowerSource
    : 'unknown'
  const status: IAndroidPowerStatus = {
    batteryPresent: o.batteryPresent,
    powerSource,
    batteryCharging: o.charging === true
  }
  if (o.batteryPresent && typeof o.batteryPercent === 'number' && Number.isFinite(o.batteryPercent)) {
    status.batteryPercent = Math.min(100, Math.max(0, Math.round(o.batteryPercent)))
  }
  return status
}
